export default function ScheduleTimeline({ slots }: { slots: string[] }) {
  return (
    <div className="w-full">
      <div className="relative h-1.5 rounded-full bg-[var(--af-border)]">
        <span className="af-timeline-dot absolute top-1/2 h-3 w-3 -translate-y-1/2 rounded-full bg-[var(--af-accent)]" />
      </div>
      <div className="mt-3 flex justify-between text-[11px] text-[var(--af-muted)]">
        {slots.map((slot) => (
          <span key={slot}>{slot}</span>
        ))}
      </div>
    </div>
  );
}
